<template>
    <div class="daily-wc mt-3 ml-3">
        <div v-if="listWinner.length > 0" class="swiper-container daily-wc__wrap" id="swiperDailyWinner">
            <div class="swiper-wrapper">
                <div v-for="(item, index) in listWinner" :key="index" class="swiper-slide daily-wc__item">
                    <img class="bg" :src="`${$store.state.mapDomain.STATIC_URL}/assets/img/event/worldcup/section-slots/bg-daily-winner.svg`" alt="background">
                    <div class="content">
                        <img class="avatar" :src="`${$store.state.mapDomain.STATIC_URL}/assets/img/event/worldcup/section-slots/avatar.png`" alt="avatar">
                        <div content="text">
                            <div class="name">{{item.username}} nhận được</div>
                            <div class="amount">{{checkStatus(item.result, item.user_data)}}</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { mapState } from 'vuex';

export default {
    data() {
        return {
        };
    },
    computed: {
        ...mapState('event/worldcup-wheel', {
            listWinner: state => state.summaryWinner.listWinner
        })
    },
    methods: {
        async getDailyWinner() {
            try {
                if (this.isLoading) {
                    return;
                }
                this.isLoading = true;
                await this.$store.dispatch('event/worldcup-wheel/getDailyWinner');
                this.isLoading = false;
                this.isSubmit = false;
            } catch (error) {
                console.log(error);
                this.isSubmit = false;
                this.isLoading = false;
                this.$alertError('Server lỗi ! Vui lòng thử lại sau!');
            }
        },
        checkStatus(item, data) {
            let $text = '';
            switch (item) {
                case 'match_win':
                    $text = `Thắng (+${data} đ)`;
                    break;
                case 'match_lose':
                    $text = `Thua (+${data} đ)`;
                    break;
                case 'match_draw':
                    $text = `Hòa (+${data} đ)`;
                    break;
                case 'money_fifty':
                    $text = '+50,000 VND';
                    break;
                case 'money_two_thousand':
                    $text = '+2,000,000 VND';
                    break;
                case 'money_one_thousand':
                    $text = '+1,000,000 VND';
                    break;
                case 'money_five_hundred':
                    $text = '+500,000 VND';
                    break;
                case 'money_three_hundred':
                    $text = '+300,000 VND';
                    break;
                case 'money_one_hundred':
                    $text = '+100,000 VND';
                    break;
                case 'money_ten':
                    $text = '+10,000 VND';
                    break;
                case 'super_return':
                    $text = 'KM 3%';
                    break;
                default:
                    $text = 'Lucky';
                    break;
            }
            return $text;
        },
        initSlider() {
            this.$swiper('#swiperDailyWinner', {
                slidesPerView: 2.7,
                autoplay: false,
                spaceBetween: 10
            });
        }
    },
    mounted() {
        this.$nextTick(async () => {
            await this.getDailyWinner();
            this.initSlider();
        });
    }
};
</script>
